import Vue from 'vue';
window.Vue = Vue;

var treeItem = Vue.component('tree-item', {
  template: '#tree-item-template',
  props: {
    item: Object,
    make_folder: Boolean,
    parent: Object,
    index: Number
  },
  data: function () {
    return {
      isOpen: true,
      _uid: 'item_' + Math.random().toString(36).substr(2, 9)
    }
  },
  computed: {
    isFolder: function () {
      return this.item.children &&
        this.item.children.length
    }
  },
  methods: {
    toggle: function () {
      if (this.isFolder) {
        this.isOpen = !this.isOpen
      }
    },
    makeFolder: function () {
      this.$emit('make-folder', this.item);
    },
    addItem: function () {
      this.$emit('add-item', this.item);
    },
    addTitleAfter: function (after) {
      this.$emit('add-title-after', after);
    },
    removeItem: function () {
      this.$emit('remove-item', this.item);
    }
  }
});

function initResearchVue() {
  let wrapper = document.querySelector('.research-form-wrapper');
  if (!wrapper) return;

  if (wrapper.__vue__ && document.body.contains(wrapper)) {
    return;
  }

  let initData = (window.treeData && Array.isArray(window.treeData) && window.treeData.length > 0)
    ? JSON.parse(JSON.stringify(window.treeData))
    : [{ name: '', _destroy: false, children: [] }];

  let research = new Vue({
    el: wrapper,
    data: function() {
      return {
        treeData: initData,
        aiLoading: false,
        importLoading: false,
        hasBackup: false,
        previousState: null
      };
    },
    computed: {
      treeDataAsString: function () {
        return JSON.stringify(this.treeData);
      }
    },
    methods: {
      generateAI: function() {
        let nameInput = document.querySelector('#research_name');
        if (!nameInput || !nameInput.value.trim()) {
          alert("Veuillez d'abord saisir le nom de la recherche.");
          return;
        }
        
        this.savePreviousState();
        this.aiLoading = true;
        let title = nameInput.value.trim();
        
        let csrfMeta = document.querySelector('meta[name="csrf-token"]');
        let csrfToken = csrfMeta ? csrfMeta.getAttribute('content') : '';
        
        fetch("/researches/generate_metadata", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-CSRF-Token": csrfToken
          },
          body: JSON.stringify({ name: title })
        })
        .then(async response => {
          const contentType = response.headers.get("content-type") || "";
          if (!response.ok || !contentType.includes("application/json")) {
            if (response.status === 401 || response.url.includes("sign_in")) {
              alert("Votre session a expiré. Veuillez vous reconnecter.");
              window.location.href = "/users/sign_in";
              return null;
            }
            let text = await response.text();
            let msg = "Une erreur est survenue lors de la génération IA.";
            try {
              let jsonErr = JSON.parse(text);
              if (jsonErr.error) msg = jsonErr.error;
            } catch(e) {}
            throw new Error(msg);
          }
          return response.json();
        })
        .then(result => {
          if (!result) return;
          this.applyResultToForm(result);
          this.hasBackup = true;
        })
        .catch(error => {
          if (!error) return;
          console.error(error);
          alert("Erreur de génération : " + error.message);
        })
        .finally(() => {
          this.aiLoading = false;
        });
      },

      importFromFile: function(event) {
        let fileInput = event.target;
        if (!fileInput.files || fileInput.files.length === 0) return;
        let file = fileInput.files[0];

        this.savePreviousState();
        this.importLoading = true;

        let formData = new FormData();
        formData.append('file', file);

        let csrfMeta = document.querySelector('meta[name="csrf-token"]');
        let csrfToken = csrfMeta ? csrfMeta.getAttribute('content') : '';

        fetch("/researches/import_file", {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "X-CSRF-Token": csrfToken
          },
          body: formData
        })
        .then(async response => {
          const contentType = response.headers.get("content-type") || "";
          if (!response.ok || !contentType.includes("application/json")) {
            if (response.status === 401 || response.url.includes("sign_in")) {
              alert("Votre session a expiré. Veuillez vous reconnecter.");
              window.location.href = "/users/sign_in";
              return null;
            }
            let text = await response.text();
            let msg = "Une erreur est survenue lors de l'importation du fichier.";
            try {
              let jsonErr = JSON.parse(text);
              if (jsonErr.error) msg = jsonErr.error;
            } catch(e) {}
            throw new Error(msg);
          }
          return response.json();
        })
        .then(result => {
          if (!result) return;
          this.applyResultToForm(result);
          this.hasBackup = true;
        })
        .catch(error => {
          if (!error) return;
          console.error(error);
          alert("Erreur d'importation : " + error.message);
        })
        .finally(() => {
          this.importLoading = false;
          if (fileInput) fileInput.value = '';
        });
      },

      applyResultToForm: function(result) {
        let improvedTitle = result.improved_title || result.name || result.title;
        if (improvedTitle && typeof improvedTitle === 'string' && improvedTitle.trim()) {
          let nameInput = document.querySelector('#research_name');
          if (nameInput) {
            nameInput.value = improvedTitle.trim();
          }
        }

        if (result.language) {
          let lang = String(result.language).toLowerCase();
          if (lang.includes('ar') || lang.includes('عرب')) lang = 'ar';
          else if (lang.includes('fr') || lang.includes('fran')) lang = 'fr';
          else if (lang.includes('en') || lang.includes('ing') || lang.includes('eng')) lang = 'en';

          let langSelect = document.querySelector('select[name="research[language]"]');
          if (langSelect) {
            langSelect.value = lang;
            langSelect.dispatchEvent(new Event('change'));
          }
          let langRadio = document.querySelector('input[name="research[language]"][value="' + lang + '"]');
          if (langRadio) {
            langRadio.checked = true;
            langRadio.dispatchEvent(new Event('change'));
          }
        }
        
        if (result.keywords) {
          let keywordsInput = document.querySelector("[data-behavior='tags']");
          if (keywordsInput && keywordsInput.__tagify) {
            keywordsInput.__tagify.removeAllTags();
            keywordsInput.__tagify.addTags(result.keywords);
          } else if (keywordsInput) {
            keywordsInput.value = Array.isArray(result.keywords) ? result.keywords.join(',') : result.keywords;
          }
        }
        
        if (result.topics && Array.isArray(result.topics)) {
          let formattedTopics = result.topics.map(t => {
            if (typeof t === 'string') {
              return { name: t, _destroy: false, children: [] };
            }
            let topicName = typeof t === 'object' && t !== null ? (t.name || t.title || t.topic || '') : String(t || '');
            let children = [];
            let rawChildren = t ? (t.children || t.subtopics || t.sub_topics) : null;
            if (Array.isArray(rawChildren)) {
              children = rawChildren.map(sub => {
                if (typeof sub === 'string') return { name: sub, _destroy: false };
                return { name: sub.name || sub.title || '', _destroy: false };
              });
            }
            return {
              name: topicName,
              _destroy: false,
              children: children
            };
          });
          this.treeData = formattedTopics;
        }
      },

      savePreviousState: function() {
        let nameInput = document.querySelector('#research_name');
        let currentTitle = nameInput ? nameInput.value : '';

        let langVal = '';
        let checkedRadio = document.querySelector('input[name="research[language]"]:checked');
        if (checkedRadio) {
          langVal = checkedRadio.value;
        } else {
          let langSelect = document.querySelector('select[name="research[language]"]');
          if (langSelect) langVal = langSelect.value;
        }

        let currentKeywords = [];
        let keywordsInput = document.querySelector("[data-behavior='tags']");
        if (keywordsInput && keywordsInput.__tagify) {
          currentKeywords = keywordsInput.__tagify.value.map(t => t.value);
        } else if (keywordsInput) {
          currentKeywords = keywordsInput.value;
        }

        this.previousState = {
          title: currentTitle,
          language: langVal,
          keywords: currentKeywords,
          treeData: JSON.parse(JSON.stringify(this.treeData))
        };
      },

      restorePreviousState: function() {
        if (!this.previousState) return;

        let nameInput = document.querySelector('#research_name');
        if (nameInput) {
          nameInput.value = this.previousState.title;
        }

        if (this.previousState.language) {
          let langRadio = document.querySelector('input[name="research[language]"][value="' + this.previousState.language + '"]');
          if (langRadio) {
            langRadio.checked = true;
            langRadio.dispatchEvent(new Event('change'));
          } else {
            let langSelect = document.querySelector('select[name="research[language]"]');
            if (langSelect) {
              langSelect.value = this.previousState.language;
              langSelect.dispatchEvent(new Event('change'));
            }
          }
        }

        let keywordsInput = document.querySelector("[data-behavior='tags']");
        if (keywordsInput && keywordsInput.__tagify) {
          keywordsInput.__tagify.removeAllTags();
          if (this.previousState.keywords && this.previousState.keywords.length) {
            keywordsInput.__tagify.addTags(this.previousState.keywords);
          }
        } else if (keywordsInput) {
          keywordsInput.value = Array.isArray(this.previousState.keywords) ? this.previousState.keywords.join(',') : (this.previousState.keywords || '');
        }

        this.treeData = JSON.parse(JSON.stringify(this.previousState.treeData));

        this.hasBackup = false;
        this.previousState = null;
      },

      makeFolder: function(item) {
        if (!item.children) Vue.set(item, "children", []);
        this.addItem({parent: item, after: null});
        this.$forceUpdate();
      },

      addItem: function({parent, after}) {
        if (!parent.children) Vue.set(parent, "children", []);
        let child = { name: "", _destroy: false };
        if (after !== undefined && after !== null) {
          parent.children.splice(after + 1, 0, child);
        } else {
          parent.children.push(child);
        }
        this.$forceUpdate();
      },

      removeItem: function(item) {
        Vue.set(item, "_destroy", true);
        this.$forceUpdate();
      },

      addTitle: function() {
        if (!this.treeData) Vue.set(this, 'treeData', []);
        this.treeData.push({
          name: "",
          _destroy: false,
          children: []
        });
        this.$forceUpdate();
      },

      addTitleAfter: function(after) {
        if (!this.treeData) Vue.set(this, 'treeData', []);
        let title = { name: "", _destroy: false, children: [] };
        this.treeData.splice(after + 1, 0, title);
        this.$forceUpdate();
      }
    }
  });

  window.researchApp = research;
}

window.initResearchVue = initResearchVue;

['DOMContentLoaded', 'turbo:load', 'turbo:render', 'turbolinks:load'].forEach(evt => {
  document.addEventListener(evt, initResearchVue);
});

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  setTimeout(initResearchVue, 50);
}
